import React from "react";
import { CreditCard, Crown, CheckCircle2, Users, ShieldCheck, BarChart3 } from "lucide-react";

const FEATURES = [
  { Icon: Users, label: "Unlimited employees in roster" },
  { Icon: ShieldCheck, label: "Unlimited certifications + photo storage" },
  { Icon: BarChart3, label: "Job site management + crew assignment" },
  { Icon: CheckCircle2, label: "Traffic-light status with email alerts" },
];

export default function Subscription() {
  return (
    <div className="p-4 md:p-10 max-w-4xl mx-auto">
      <div className="mb-8">
        <div className="inline-block bg-safety-yellow text-black px-2 py-0.5 font-bold uppercase tracking-widest text-[10px] mb-3">Subscription</div>
        <h1 className="font-heading text-4xl md:text-6xl">YOUR PLAN</h1>
        <p className="text-muted-foreground mt-2 text-sm md:text-base">Manage billing, seats, and tier.</p>
      </div>

      <div className="brutal-card p-6 md:p-8 mb-5">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <div className="text-xs font-bold uppercase tracking-widest text-muted-foreground inline-flex items-center gap-2">
              <Crown className="w-4 h-4 text-safety-yellow" /> Current Tier
            </div>
            <div className="font-heading text-4xl md:text-5xl mt-2">FOUNDATION</div>
            <div className="text-sm text-muted-foreground mt-1">Free preview tier · all core features unlocked</div>
          </div>
          <div className="inline-flex items-center gap-2 border-2 border-status-current text-status-current px-3 h-10 font-black uppercase tracking-wider text-xs">
            <CheckCircle2 className="w-4 h-4" strokeWidth={3} /> Active
          </div>
        </div>

        <div className="mt-6 grid sm:grid-cols-2 gap-3">
          {FEATURES.map((f) => (
            <div key={f.label} className="flex items-center gap-3 border-2 border-foreground/30 dark:border-safety-yellow/40 px-3 py-3">
              <f.Icon className="w-5 h-5 text-safety-yellow flex-shrink-0" strokeWidth={2.5} />
              <span className="text-sm font-bold">{f.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="brutal-card p-6 md:p-8">
        <div className="flex items-center gap-3 mb-3">
          <CreditCard className="w-6 h-6 text-safety-yellow" strokeWidth={2.5} />
          <h2 className="font-heading text-2xl">Billing</h2>
        </div>
        <p className="text-sm text-muted-foreground mb-5">
          Paid tiers (Crew + Enterprise) with multi-company analytics, audit logs, and SSO are coming soon.
          You&apos;ll be notified before billing begins.
        </p>
        <button disabled data-testid="upgrade-btn"
          className="btn-primary w-full sm:w-auto opacity-60 cursor-not-allowed">
          Upgrade — Coming Soon
        </button>
      </div>
    </div>
  );
}
